// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__2cZ-d","sendOtp":"AuthorizeToLogin_sendOtp__EV2pc"};